"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, FlexColumn, Separator, Spinner, TextBody, useToasts } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useCallback, useContext, useMemo, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { SwapToastContent } from "../../../../components/SwapToastContent";
import { useBalances } from "../../../../providers/BalancesProvider";
import { FlagContext } from "../../../../providers/FlagProvider/FlagContext";
import { readSwapImpactFromQuote } from "../provider/readSwapImpact";
import { useSwapContext } from "../provider/SwapContext";
import { useCanLoadQuote } from "../provider/use-can-load-quote";
import { SWAP_IMPACT_WARNING_THRESHOLD } from "./constants";
import { SwapActions } from "./SwapActions";
import { SwapConfirmationModal } from "./SwapConfirmationModal";
import { SwapDestination } from "./SwapDestination";
import { SwapDetails } from "./SwapDetails";
import { SwapForm } from "./SwapForm";
import { SwapHeader } from "./SwapHeader";
import { SwapImpact } from "./SwapImpact";
import { SwapPanel } from "./SwapPanel";
import { SwapWarnings } from "./SwapWarning";
export function SwapModule(t0) {
  const $ = _c(61);
  let buttonColor;
  let onCompleted;
  let swapPanelProps;
  let t1;
  if ($[0] !== t0) {
    ({
      onCompleted,
      surface: t1,
      buttonColor,
      ...swapPanelProps
    } = t0);
    $[0] = t0;
    $[1] = buttonColor;
    $[2] = onCompleted;
    $[3] = swapPanelProps;
    $[4] = t1;
  } else {
    buttonColor = $[1];
    onCompleted = $[2];
    swapPanelProps = $[3];
    t1 = $[4];
  }
  const surface = t1 === undefined ? "inline" : t1;
  const {
    control
  } = useFormContext();
  const {
    addToast,
    removeToast
  } = useToasts();
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["customDestinationWalletEnabled", "fromCurrency"];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== control) {
    t3 = {
      control,
      name: t2
    };
    $[6] = control;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [customDestinationWalletEnabled, fromCurrency] = useWatch(t3);
  const t = useTranslations("wallet.SwapModule");
  const {
    hasQuoteError,
    variant,
    reset,
    quote,
    shouldShowConfirmationModal
  } = useSwapContext();
  const {
    refreshBalances
  } = useBalances();
  const [pendingToastId, setPendingToastId] = useState();
  let t4;
  if ($[8] !== onCompleted || $[9] !== pendingToastId || $[10] !== refreshBalances || $[11] !== removeToast || $[12] !== reset) {
    t4 = status => {
      removeToast(pendingToastId);
      setPendingToastId(undefined);
      onCompleted(status);
      reset();
      setTimeout(refreshBalances, 1000);
    };
    $[8] = onCompleted;
    $[9] = pendingToastId;
    $[10] = refreshBalances;
    $[11] = removeToast;
    $[12] = reset;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleCompleted = t4;
  let t5;
  if ($[14] !== addToast || $[15] !== quote?.swapRoutes[0] || $[16] !== t) {
    t5 = () => {
      const route = quote?.swapRoutes[0];
      const toastId = addToast({
        title: <TextBody weight="semibold">{t("swapping")}</TextBody>,
        duration: Number.POSITIVE_INFINITY,
        icon: <Spinner size="xs" />,
        description: route ? <SwapToastContent route={route} /> : undefined
      });
      setPendingToastId(toastId);
    };
    $[14] = addToast;
    $[15] = quote?.swapRoutes[0];
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const onTransactionStart = t5;
  const canFetchQuote = useCanLoadQuote();
  let swapImpact;
  let t6;
  if ($[18] !== quote) {
    swapImpact = quote ? readSwapImpactFromQuote(quote) : undefined;
    t6 = swapImpact && bn(swapImpact.percent).lt(SWAP_IMPACT_WARNING_THRESHOLD);
    $[18] = quote;
    $[19] = swapImpact;
    $[20] = t6;
  } else {
    swapImpact = $[19];
    t6 = $[20];
  }
  const hasHighImpact = t6;
  const [collapsed, setCollapsed] = useState(true);
  const {
    flags
  } = useContext(FlagContext);
  const usdSwapInputGloballyEnabled = Boolean(flags.usdSwapInputEnabled);
  const usdSwapInputDisabledTokens = flags.usdSwapInputDisabledTokens ?? [];
  let t7;
  bb0: {
    if (!usdSwapInputGloballyEnabled) {
      t7 = false;
      break bb0;
    }
    if (!fromCurrency) {
      t7 = usdSwapInputGloballyEnabled;
      break bb0;
    }
    const key = `${fromCurrency.chainIdentifier}:${fromCurrency.contractAddress}`;
    t7 = !usdSwapInputDisabledTokens.includes(key);
  }
  const computedUsdInputEnabled = t7;
  const t8 = variant === "frosted" && "border-frosted-2 bg-frosted-1 backdrop-blur-xl";
  let t9;
  if ($[21] !== t8) {
    t9 = classNames("rounded-xl border border-border-1 bg-bg-primary", t8);
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== surface) {
    t10 = surface === "inline" && <><SwapHeader /><Separator /></>;
    $[23] = surface;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = swapPanelProps.enableUsdInput ?? computedUsdInputEnabled;
  let t12;
  if ($[25] !== surface || $[26] !== swapPanelProps || $[27] !== t11) {
    t12 = <SwapPanel surface={surface} {...swapPanelProps} enableUsdInput={t11} />;
    $[25] = surface;
    $[26] = swapPanelProps;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Separator />;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== customDestinationWalletEnabled) {
    t14 = customDestinationWalletEnabled && <><SwapDestination /><Separator /></>;
    $[30] = customDestinationWalletEnabled;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== canFetchQuote || $[33] !== collapsed || $[34] !== hasQuoteError) {
    t15 = canFetchQuote && !hasQuoteError && <><SwapDetails collapsed={collapsed} setCollapsed={setCollapsed} /><Separator /></>;
    $[32] = canFetchQuote;
    $[33] = collapsed;
    $[34] = hasQuoteError;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== collapsed || $[37] !== hasHighImpact || $[38] !== swapImpact) {
    t16 = hasHighImpact && collapsed && <><SwapImpact percent={swapImpact.percent} usd={swapImpact.usd} /><Separator /></>;
    $[36] = collapsed;
    $[37] = hasHighImpact;
    $[38] = swapImpact;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== buttonColor || $[41] !== handleCompleted || $[42] !== onTransactionStart || $[43] !== surface) {
    t17 = <SwapActions buttonColor={buttonColor} onCompleted={handleCompleted} onTransactionStart={onTransactionStart} surface={surface} />;
    $[40] = buttonColor;
    $[41] = handleCompleted;
    $[42] = onTransactionStart;
    $[43] = surface;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== t10 || $[46] !== t12 || $[47] !== t14 || $[48] !== t15 || $[49] !== t16 || $[50] !== t17 || $[51] !== t9) {
    t18 = <FlexColumn className={t9} data-testid="swap-module">{t10}{t12}{t13}{t14}{t15}{t16}{t17}</FlexColumn>;
    $[45] = t10;
    $[46] = t12;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
    $[50] = t17;
    $[51] = t9;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SwapWarnings />;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t18) {
    t20 = <SwapForm>{t18}{t19}</SwapForm>;
    $[54] = t18;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== shouldShowConfirmationModal) {
    t21 = <SwapConfirmationModal open={shouldShowConfirmationModal} />;
    $[56] = shouldShowConfirmationModal;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t20 || $[59] !== t21) {
    t22 = <>{t20}{t21}</>;
    $[58] = t20;
    $[59] = t21;
    $[60] = t22;
  } else {
    t22 = $[60];
  }
  return t22;
}